<template>
  <li class="headline">
    {{ t('menu.tabs.storytelling') }}
  </li>
  <li v-if="session.sessionId" @click="grimoire.toggleNight">
    <template v-if="grimoire.gamePhase === 'pregame'">
      {{ t('menu.firstNightSwitch') }}
    </template>
    <template v-if="grimoire.gamePhase === 'firstNight' || grimoire.gamePhase === 'otherNight'">
      {{ t('menu.daySwitch') }}
    </template>
    <template v-if="grimoire.gamePhase === 'day'">
      {{ t('menu.nightSwitch') }}
    </template>
    <template v-if="grimoire.gamePhase === 'postgame'">
      {{ t('menu.newGame') }}
    </template>
    <em>[S]</em>
  </li>
  <li v-if="!session.isPlayerOrSpectator" @click="playersStore.distributeRolesAction()">
    {{ t('menu.sendRoles') }}
    <em><font-awesome-icon icon="theater-masks" class="fa fa-theater-masks" /></em>
  </li>
  <li @click="grimoire.setSecretVote(!grimoire.isSecretVote)">
    {{ t('menu.secretVote') }}
    <em>
      <font-awesome-icon :icon="[
        'fas',
        grimoire.isSecretVote ? 'check-square' : 'square',
      ]" />
    </em>
  </li>
  <li :class="{ disabled: !grimoire.isVoteHistoryAllowed && session.isPlayerOrSpectator }"
    @click="grimoire.toggleModal('voteHistory')">
    {{ t('menu.voteHistory') }}<em>[V]</em>
  </li>
  <li @click="grimoire.setVoteHistoryAllowed(!grimoire.isVoteHistoryAllowed)">
    {{ t('menu.allowVoteHistory') }}
    <em>
      <font-awesome-icon :icon="[
        'fas',
        grimoire.isVoteHistoryAllowed ? 'check-square' : 'square',
      ]" />
    </em>
  </li>
  <li @click="grimoire.setAllowSelfNaming(!grimoire.allowSelfNaming)">
    {{ t('menu.selfNaming') }}
    <em><font-awesome-icon :icon="[
      'fas',
      grimoire.allowSelfNaming ? 'check-square' : 'square',
    ]" /></em>
  </li>
  <li @click="grimoire.setAllowTextChat(!grimoire.isTextChatAllowed)">
    {{ t('menu.allowTextChat') }}
    <em><font-awesome-icon :icon="[
      'fas',
      grimoire.isTextChatAllowed ? 'check-square' : 'square',
    ]" /></em>
  </li>
  <li :class="{ disabled: !grimoire.isTextChatAllowed }" @click="grimoire.setAllowWhisper(!grimoire.isWhisperAllowed)">
    {{ t('menu.allowWhisper') }}
    <em><font-awesome-icon :icon="[
      'fas',
      grimoire.isWhisperAllowed ? 'check-square' : 'square',
    ]" /></em>
  </li>
  <li :class="{ disabled: !grimoire.isTextChatAllowed }"
    @click="grimoire.setAllowSignalHistory(!grimoire.isSignalHistoryAllowed)">
    {{ t('menu.allowSignalHistory') }}
    <em><font-awesome-icon :icon="[
      'fas',
      grimoire.isSignalHistoryAllowed ? 'check-square' : 'square',
    ]" /></em>
  </li>
  <li v-if="grimoire.gamePhase !== 'postgame'" @click="grimoire.endGame">
    {{ t('menu.endGame') }}
    <em><font-awesome-icon icon="ranking-star" class="fa fa-ranking-star" /></em>
  </li>
</template>

<script setup lang="ts">
import {
  useGrimoireStore,
  useLocaleStore,
  usePlayersStore,
  useSessionStore,
} from "@/stores";

const grimoire = useGrimoireStore();
const locale = useLocaleStore();
const t = locale.t;
const playersStore = usePlayersStore();
const session = useSessionStore();
</script>

<style lang="scss" src="./Menu.scss" scoped></style>
